var map = {
	"./IMG_7953.webp": 6058,
	"./IMG_8024.webp": 995,
	"./IMG_8278.webp": 5328,
	"./IMG_8350.webp": 5173,
	"./IMG_8353.webp": 2744,
	"./PXL_20260503_004154820.webp": 575,
	"./fallenAngel.webp": 2840,
	"./jinx.webp": 5730,
	"./love.webp": 3913,
	"./lydia.webp": 6544,
	"./mucca.webp": 6000,
	"./mural.webp": 2218,
	"./mushroomForest.webp": 7690,
	"./pixelForest.webp": 3914,
	"./plates.webp": 5972,
	"./selfPortrait.webp": 8708,
	"./spiderman.webp": 1256,
	"./storyboardArtStudy.webp": 6988,
	"./vampire.webp": 6269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8140;